// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"00b80b37","226":"b210774c"}[chunkId] + ".chunk.css";
};